// 用户相关 API，根据后端文档实现
import httpUtil from '@/utils/axios'

export const UsersAPI = {
  // 获取所有用户（ROLE_ADMIN）
  getAll: (params = {}) => httpUtil.get('/users', params),

  // 获取用户详情（ROLE_ADMIN 或 当前用户）
  getById: (id) => httpUtil.get(`/users/${id}`),

  // 删除用户（ROLE_ADMIN）
  deleteById: (id) => httpUtil.delete(`/users/${id}`)
}

// 管理员接口 - 工单账号管理
export const AdminTechniciansAPI = {
  // 列出工单账号（支持关键字 q，可选 role）
  list: (q = '', role = '') => httpUtil.get('/admin/technicians', { ...(q ? { q } : {}), ...(role ? { role } : {}) }),
  // 获取工单账号详情
  getById: (id) => httpUtil.get(`/admin/technicians/${id}`),
  // 创建工单账号
  create: (payload) => httpUtil.post('/admin/technicians', payload),
  // 更新工单账号（用户名/名称/手机号）
  update: (id, payload) => httpUtil.put(`/admin/technicians/${id}`, payload),
  // 重置工单账号密码
  resetPassword: (id, newPassword) => httpUtil.put(`/admin/technicians/${id}/password`, { newPassword }),
  // 删除工单账号
  deleteById: (id) => httpUtil.delete(`/admin/technicians/${id}`)
}

export default UsersAPI
